import { IOrder, ISaleHistory, ISalesHistoryReturnItem, ITransaction } from "../services/sale.service";
import { Client } from "./client.model";

export class Sale {
  private _id: string;
  private _type: string;
  private _orderType: string;
  private _status: string;
  private _initiatingLocation: string;
  private _pickupLocation: string;
  private _registerId: string;
  private _returns: ISalesHistoryReturnItem[];
  private _date: string;
  private _customerId: string;
  private _saleeChId: string;
  private _order: IOrder;
  private _client: Client;
  private _transactions: ITransaction[];

  constructor( data: ISaleHistory, client?: Client) {
    this._id = data.id;
    this._type = data.type;
    this._date = data.date;
    this._customerId = data.customerId;
    this._orderType = data.orderType;
    this._status = data.status;
    this._initiatingLocation = data.initiatingLocation;
    this._pickupLocation = data.pickupLocation;
    this._registerId = data.registerId;
    this._saleeChId = data.saleChId;
    this._returns = data.returns;
    this._client = client;
    this._order = data.order;
    this._transactions = data.transactions;
  }

  public get id(): string {
    return this._id;
  }

  public get type(): string {
    return this._type;
  }

  public get status(): string {
    return this._status;
  }

  public get orderType(): string {
    return this._orderType;
  }

  public get initiatingLocation(): string {
    return this._initiatingLocation;
  }

  public get pickupLocation(): string {
    return this._pickupLocation;
  }

  public get registerId(): string {
    return this._registerId;
  }

  public get returns(): ISalesHistoryReturnItem[] {
    return this._returns;
  }

  public get date(): string {
    return this._date;
  }

  public get customerId(): string {
    return this._customerId;
  }

  public get saleChId(): string {
    return this._saleeChId;
  }

  public get client(): Client {
    return this._client;
  }

  public get order(): IOrder {
    return this._order;
  }

  public get transactions(): ITransaction[] {
    return this._transactions;
  }
}
